/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies
*/
import React from 'react';
import SubHeader from 'signer/components/common/sub-header';
import logger from 'common/logger';
import createReactClass from 'create-react-class';

const SubHeaderDelegate = createReactClass({

  showDelegateModal() {
    logger.track('Reassign.SubHeader.onClick');
    this.props.app.router.displayFullScreenModal('confirmDelegate');
  },

  isVisible() {
    return this.props.app.canDelegate();
  },

  render() {
    if (this.isVisible()) {
      return (
        <SubHeader
          onCTAClick={this.showDelegateModal} />
      );
    } else {
      return false;
    }
  },
});

module.exports = SubHeaderDelegate;
